import React from "react";
import take from "lodash/take";
import canUseDom from "../../../utils/can-use-dom";
import { SimpleSlider } from '../basic/simple-slider.js';
import { SectionName } from "../basic/section-name.js";
import {collectionSection} from '../collection-templates/collection-layout-helper';


import { wrapCollectionLayout } from "@quintype/components";

function FullscreenSimpleSliderBase({collection, stories, config,  associatedMetadata}) {
  const storiesToRender = canUseDom ? stories : take(stories, 1);
  const  {'show_collection_title': collectionName = true} = associatedMetadata;
  return <div className="component-wrapper">
 {collectionName ? <SectionName  name={collection.name} type="large" section={collectionSection(config, collection)}/> : null }
  <SimpleSlider stories={storiesToRender} config={config} heading={collection.name} />
  </div>
  
}

export const FullscreenSimpleSlider = wrapCollectionLayout(FullscreenSimpleSliderBase);
